export default __webpack_public_path__ + "static/scoord3d-8a30c24da7bc6b158482c2bf5e8b4330.png";